import React from "react";
import PdfPage from "../components/PdfPage";
import "./index.css";
const CommonTerms = () => {
  return (
    <main>
      <PdfPage
        h2={"Common Terms Of Share Market"}
        img={"/img/policies.jpg"}
        pdf1={"https://api.orbitsecurities.com.pk/media/cms/documents/common-terms-of-share-market-english.pdf"}
        pdf1Text={"Download In English"}
        pdf2={"https://api.orbitsecurities.com.pk/media/cms/documents/common-terms-of-share-market-urdu.pdf"}
        pdf2Text={"Download In Urdu"}
      />
    </main>
  );
};

export default CommonTerms;
